import { useState, useContext, useEffect } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import classes from "./IPDRouteLayout.module.css";
import { useTranslation } from "react-i18next";
import AuthContext from "../../../store/auth-context";
import Loader from "../../UI/Loader";

const IPDRouteLayout = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [menuOpen, setMenuOpen] = useState(false);

  const isIpdEnabled = authCtx.hospitalData?.boolIpdAccess;
  const isLoading = authCtx.isLoadingHospitalData;

  useEffect(() => {
    if (!isLoading && isIpdEnabled === false) {
      navigate("/access-denied");
    }
  }, [isIpdEnabled, isLoading, navigate]);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  if (isLoading) {
    return <Loader />;
  }

  if (isIpdEnabled === false) {
    return null;
  }

  return (
    <div className={classes.container}>
      {/* 🔹 Top Navbar */}
      <nav className={classes.navbar}>

        {/* 🔹 Hamburger button (only visible on mobile) */}
        <button className={classes.hamburger} onClick={toggleMenu}>
          <i className="fa fa-bars"></i>
        </button>

        {/* 🔹 Desktop Menu */}
        <ul className={`${classes.menu} ${menuOpen ? classes.show : ""}`}>
          <li>
            <NavLink to="/dashboard/ipd" className={({ isActive }) => (isActive ? classes.active : classes.link)} end>
              <i className="fa fa-bed"></i> {t("IPD")}
            </NavLink>
          </li>
          <li>
            <NavLink to="/dashboard/ipd/newpatientadmission" className={({ isActive }) => (isActive ? classes.active : classes.link)}>
              <i className="fa fa-user-plus"></i> {t("Create IPD")}
            </NavLink>
          </li>
          <li>
            <NavLink to="/dashboard/ipd/availability" className={({ isActive }) => (isActive ? classes.active : classes.link)}>
              <i className="fa fa-battery-half"></i> {t("Availability")}
            </NavLink>
          </li>

          <li>
            <NavLink to="/dashboard/ipd/billing" className={({ isActive }) => (isActive ? classes.active : classes.link)}>
              <i className="fa fa-file-text"></i> {t("Billing")}
            </NavLink>
          </li>
          <li>
            <NavLink to="/dashboard/ipd/reports" className={({ isActive }) => (isActive ? classes.active : classes.link)}>
              <i className="fa fa-file"></i> {t("Reports")}
            </NavLink>
          </li>
          <li>
            <NavLink to="/dashboard/ipd/configuration" className={({ isActive }) => (isActive ? classes.active : classes.link)}>
              <i className="fa fa-cog"></i>{t("IPD Config")}
            </NavLink>
          </li>
        </ul>
      </nav>

      {/* 🔹 Main Content */}
      <main className={classes.content}>
        <Outlet />
      </main>
    </div>
  );
};

export default IPDRouteLayout;
